import { Component, OnInit } from '@angular/core';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { ParametersDTO } from 'src/app/infraestructure/interfaces/parameters/ParametersDTO';
import { ConsultaInformeEncuestasI } from 'src/app/infraestructure/models/consultaInformeEncuestas';
import { ConsultaInformeSolicitudesI } from 'src/app/infraestructure/models/consultaInformeSolicitudes';
import { ConsultarInformesI } from 'src/app/infraestructure/models/consultarInformes';
import { ObtenerPreguntasRespuestasI } from 'src/app/infraestructure/models/obtenerPreguntasRespuestas';
import { ParametricListsService } from 'src/app/infraestructure/services/parametric-lists/parametric-lists.service';
import { ProgrammerApiService } from 'src/app/infraestructure/services/programmer/programmer-api.service';
import { SurveyService } from 'src/app/infraestructure/services/survey/survey.service';

@Component({
  selector: 'app-informes-solicitudes-servicio',
  templateUrl: './informes-solicitudes-servicio.component.html',
  styleUrls: ['./informes-solicitudes-servicio.component.scss']
})
export class InformesSolicitudesServicioComponent implements OnInit {
  
  private $topSubcription = new Subject<void>();
  $parametricList: ParametersDTO = new ParametersDTO();
  preguntasEncuesta: ObtenerPreguntasRespuestasI[] = [];
  dataSearch = {} as ConsultarInformesI;
  dataTableRequest: ConsultaInformeSolicitudesI[] = [];
  dataTableSurvey: ConsultaInformeEncuestasI[] = []

  tipoInforme: number = -1;

  constructor(private _listSrv: ParametricListsService,
              private encuestaSrv: SurveyService,
              private programmerSrv: ProgrammerApiService) {  }
  
  ngOnInit(): void {
    this.getParametroDetalles();
  }

  getParametroDetalles() {
    combineLatest(
      this._listSrv.getDataLists('TIP_TIPO_REPORTE'),
      this._listSrv.getDataLists('TIP_VEHICULOS'),
      this.encuestaSrv.getObtenerPreguntas(),
    )
    .pipe(takeUntil(this.$topSubcription))
    .subscribe(([
      Param_1, Param_2, Preguntas
    ]: any) => {
      if(Param_1.code === 200) this.$parametricList.typeTypeReport = Param_1.data;
      if(Param_2.code === 200) this.$parametricList.typeTypeVehicle = Param_2.data;
      if(Preguntas.code === 200) this.preguntasEncuesta = Preguntas.data;
    });
  }

  onConsult() {
    if (this.tipoInforme == this.$parametricList.typeTypeReport[0].idParametroDetalle) {
      this.programmerSrv.postJSonReporteSolicitudes(this.dataSearch)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if(res.code === 200) this.dataTableRequest = res.data;
      });
    } else if (this.tipoInforme == this.$parametricList.typeTypeReport[1].idParametroDetalle) {
      this.programmerSrv.postJSonReporteEncuesta(this.dataSearch)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if(res.code === 200) this.dataTableSurvey = res.data;
      });
    }
  }

  onExport(data: boolean) {
    if(data === true) {
      if (this.tipoInforme == this.$parametricList.typeTypeReport[0].idParametroDetalle) {
        this.programmerSrv.postExcelReporteSolicitudes(this.dataSearch)
        .pipe(takeUntil(this.$topSubcription))
        .subscribe(res => {
          if (res.data[0].base64) this.descargarArchivo(res.data[0].base64, 'solicitudes de servicio');
        });
      } else if (this.tipoInforme == this.$parametricList.typeTypeReport[1].idParametroDetalle) {
        this.programmerSrv.postExcelReporteEncuesta(this.dataSearch)
        .pipe(takeUntil(this.$topSubcription))
        .subscribe(res => {
          if (res.data[0].base64) this.descargarArchivo(res.data[0].base64, 'encuesta de satisfacción');
        });
      }
    }
  }

  descargarArchivo(base64: string, message: string): void {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = `Informe ${message} del ${this.dataSearch.dtFechaInicio} al ${this.dataSearch.dtFechaFin}`;

    // Agrega el enlace al DOM y haz clic en él para iniciar la descarga
    document.body.appendChild(a);
    a.click();

    // Limpia el enlace y la URL
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}